module.exports = __webpack_public_path__ + "static/media/mingxing_bg_09.33eca04b.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/mingxing_bg_09.png
// module id = 1798
// module chunks = 0 1